import { Component, Input, OnInit } from '@angular/core';
import { formatPounds } from 'src/app/components/shared/pipes/app-pounds-pipe';
import { BeatYourBrokerResultModel } from 'src/app/models/beat-your-broker-result.model';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';

@Component({
  selector: 'app-comparison-table',
  templateUrl: './comparison-table.component.html',
  styleUrls: ['./comparison-table.component.scss'],
})
export class ComparisonTableComponent implements OnInit {

      
  @Input() quickQuote: QQQuestionnaireViewModel; 
  @Input() result: BeatYourBrokerResultModel;
  
  headerData = {
    columns: [
      { value: 'Dual Life', columnClass: 'header-1' }, 
      { value: 'Assura + Protect', columnClass: 'header-2' },
      { value: 'Current joint life', columnClass: 'header-3' },
    ]
  }
  
  tableData = {
    rows: [{
      title: 'Life Cover',
      rowClass: 'table-row', 
      columns: [
        { value: 'Life Cover', columnClass: 'table-cell-1' }, 
        { value: '', expression: '${ProtectionLevel_1}', columnClass: 'table-cell-2' },
        { value: '', expression:  '${ProtectionLevel_1}', columnClass: 'table-cell-3' },
      ],
    },
    {
      title: 'Monthly Premium',
      rowClass: 'table-row',
      columns: [
        { value: 'Monthly Premium', columnClass: 'table-cell-1' }, 
        { value: '', expression:  '${formatCurrency(assuraPremium)}', columnClass: 'table-cell-2' },
        { value: '', expression:  '${formatCurrency(currentPremium)}', columnClass: 'table-cell-3' },
      ],
    },
    {
      title: 'Policyholder Benefits',
      rowClass: 'table-row',
      columns: [
        { value: 'Policyholder Benefits', columnClass: 'table-cell-1 expandable' }, 
        { value: 'Comprehensive', columnClass: 'table-cell-2' },
        { value: 'None', columnClass: 'table-cell-3' },
      ],
      subRows: [
        {
          rowClass: 'table-row sub',
          columns: [
            { value: '', columnClass: 'table-cell-1 sub' },
            { value: 'Retail Cashback / Discounts', columnClass: 'table-cell-2 sub' },
            { value: '', columnClass: 'table-cell-3 sub' },
          ],
        },
        {
          rowClass: 'table-row sub',
          columns: [
            { value: '', columnClass: 'table-cell-1 sub' },
            { value: 'Travel Discounts', columnClass: 'table-cell-2 sub' },
            { value: '', columnClass: 'table-cell-3 sub' },
          ],
        },
        {
          rowClass: 'table-row sub',
          columns: [
            { value: '', columnClass: 'table-cell-1 sub' },
            { value: 'Healthy Lifestyle incentives', columnClass: 'table-cell-2 sub' },
            { value: '', columnClass: 'table-cell-3 sub' },
          ],
        },
        {
          rowClass: 'table-row sub',
          columns: [
            { value: '', columnClass: 'table-cell-1 sub' },
            { value: 'Gym Discounts', columnClass: 'table-cell-2 sub' },
            { value: '', columnClass: 'table-cell-3 sub' },
          ],
        },
        {
          rowClass: 'table-row sub',
          columns: [
            { value: '', columnClass: 'table-cell-1 sub' },
            { value: 'Concierge Services', columnClass: 'table-cell-2 sub' },
            { value: '', columnClass: 'table-cell-3 sub' },
          ],
        },
        {
          rowClass: 'table-row sub',
          columns: [
            { value: '', columnClass: 'table-cell-1 sub' },
            { value: 'Global Periodical Access', columnClass: 'table-cell-2 sub' },
            { value: '', columnClass: 'table-cell-3 sub' },
          ],
        },
      ],
    },
    {
      title: 'Extended Health Cover',
      rowClass: 'table-row',
      columns: [
        { value: 'Extended Health Cover', columnClass: 'table-cell-1 expandable' }, 
        { value: 'Comprehensive', columnClass: 'table-cell-2' },
        { value: 'Limited', columnClass: 'table-cell-3' },
      ],
      subRows: [
        {
          rowClass: 'table-row sub',
          columns: [
            { value: '', columnClass: 'table-cell-1 sub' },
            { value: 'GP Services - 24/7', columnClass: 'table-cell-2 sub' },
            { value: '', columnClass: 'table-cell-3 sub' },
          ],
        },
        {
          rowClass: 'table-row sub',
          columns: [
            { value: '', columnClass: 'table-cell-1 sub' },
            { value: 'Face-to-face Consultation', columnClass: 'table-cell-2 sub' },
            { value: 'Second Medical Opinion', columnClass: 'table-cell-3 sub' },
          ],
        },
        {
          rowClass: 'table-row',
          columns: [
            { value: '', columnClass: 'table-cell-1 sub' },
            { value: 'Direct Prescription Services', columnClass: 'table-cell-2 sub' },
            { value: '', columnClass: 'table-cell-3 sub' },
          ],
        },
      ],
    },
    {
      title: 'Partner Cover',
      rowClass: 'table-row',
      columns: [
        { value: 'Partner Cover', columnClass: 'table-cell-1 expandable' }, 
        { value: 'Yes', columnClass: 'table-cell-2' },
        { value: 'Yes', columnClass: 'table-cell-3' },
      ],
      subRows: [
        {
          rowClass: 'table-row sub',
          columns: [
            { value: 'Partner Cover Type', columnClass: 'table-cell-1 sub' },
            { value: 'Dual', columnClass: 'table-cell-2 sub' },
            { value: 'Joint', columnClass: 'table-cell-3 sub' },
          ],
        },
        {
          rowClass: 'table-row sub',
          columns: [
            { value: 'Lives Covered', columnClass: 'table-cell-1 sub' },
            { value: 'Both', columnClass: 'table-cell-2 sub' },
            { value: 'First', columnClass: 'table-cell-3 sub' },
          ],
        },
        {
          rowClass: 'table-row sub',
          columns: [
            { value: 'Maximum Benefit (% of Sum Assured)', columnClass: 'table-cell-1 sub' },
            { value: '200%', columnClass: 'table-cell-2 sub' },
            { value: '100%', columnClass: 'table-cell-3 sub' },
          ],
        }
      ]
    }]
  };  

  constructor() { }

  ngOnInit() {

    let data = this.quickQuote.answersObject;
    this.tableData = this.prepareData(this.tableData, data);
  }

  prepareData(tabledata: any, data: any) {
    if (!tabledata || !tabledata.rows) {
      console.error('tabledata.rows is undefined!');
      return; 
    }
    
    return {
      ...tabledata,
      rows: tabledata.rows.map((row: any) => ({
        ...row,
        columns: row.columns.map((column: any) => ({
          ...column,
          value: column.expression ? this.injectValues(column, data) : column.value
        }))
      }))
    };
  } 

  injectValues(column: any, data: any)
  {
    const func = new Function('context', `with(context) { return \`${column.expression}\`; }`)

      const context = {
          ...data,
          ...this.result,
          formatCurrency: this.formatCurrency
      };

      return func(context);

  }

  public formatCurrency(amount: any)
  {
    return formatPounds(amount);
  }

}
